(() => {
  function getVariantId(sectionEl) {
    // URL is most reliable if the theme updates it
    const urlId = new URLSearchParams(window.location.search).get("variant");
    if (urlId) return urlId;

    // Fallback: hidden input in the product form
    const idInput = sectionEl.querySelector('form[action*="/cart/add"] input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function updateVariantDescriptions(sectionEl) {
    const wrappers = sectionEl.querySelectorAll(".variant-description-wrapper");
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const sectionId = wrapper.dataset.sectionId;
      const dataEl = document.getElementById(`VariantDescData-${sectionId}`);
      const outEl = document.getElementById(`VariantDescription-${sectionId}`);
      if (!dataEl || !outEl) return;

      let map = {};
      try {
        map = JSON.parse(dataEl.textContent || "{}");
      } catch (e) {
        return;
      }

      const variantId = getVariantId(sectionEl);
      const text = variantId && map[variantId] ? map[variantId] : "";

      outEl.innerHTML = text || "";
    });
  }

  function getMainProductSection(fromEl) {
    return (
      (fromEl && fromEl.closest && fromEl.closest('section[id^="MainProduct-"]')) ||
      document.querySelector('section[id^="MainProduct-"]') ||
      document
    );
  }

  function scheduleUpdate(fromEl) {
    const sectionEl = getMainProductSection(fromEl);
    updateVariantDescriptions(sectionEl);
    requestAnimationFrame(() => updateVariantDescriptions(sectionEl));
    setTimeout(() => updateVariantDescriptions(sectionEl), 80);
    setTimeout(() => updateVariantDescriptions(sectionEl), 200);
  }

  document.addEventListener("DOMContentLoaded", () => scheduleUpdate(document));

  // Variant radios/selects trigger change
  document.addEventListener("change", (e) => scheduleUpdate(e.target));

  // Some themes/apps fire custom events; harmless if none exist
  document.addEventListener("variant:change", (e) => scheduleUpdate(e.target));

  // URL-based updates
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  history.pushState = function () {
    const ret = _pushState.apply(this, arguments);
    scheduleUpdate(document);
    return ret;
  };

  history.replaceState = function () {
    const ret = _replaceState.apply(this, arguments);
    scheduleUpdate(document);
    return ret;
  };

  window.addEventListener("popstate", () => scheduleUpdate(document));
})();
